module.exports = __webpack_public_path__ + "static/media/gokrisp-social-packs.06a8be6a.png";